import { render, staticRenderFns } from "./centerProfile.vue?vue&type=template&id=3873c504&scoped=true&"
import script from "./centerProfile.vue?vue&type=script&lang=js&"
export * from "./centerProfile.vue?vue&type=script&lang=js&"
import style0 from "./centerProfile.vue?vue&type=style&index=0&id=3873c504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3873c504",
  null
  
)

export default component.exports